import { configuration as defaultV2Configuration } from '../configurations/default_v2';
import { configuration as defaultV3Configuration } from '../configurations/default_v3';
import { configuration as defaultV4Configuration } from '../configurations/default_v4';
import { configuration as theme_016V2Configuration } from '../configurations/theme_016_v2';
import { configuration as theme_016V4Configuration } from '../configurations/theme_016_v4';
import { PlatformConfiguration } from '../model';

type Version = 'v2' | 'v3' | 'v4';
const CONFIGURATION_MAP: Record<string, PlatformConfiguration> = {
  v2: defaultV2Configuration,
  v3: defaultV3Configuration,
  v4: defaultV4Configuration,
  // We have some weird mixed v2/v3 styles for safecasino v2 cashier
  theme_016_v2: theme_016V2Configuration,
  theme_016_v4: theme_016V4Configuration,
};

interface PlatformConfigurationRegistry {
  get(name: string, version: Version): PlatformConfiguration;
  getDefault(version: Version): PlatformConfiguration;
}

export const platformConfigurationRegistry: PlatformConfigurationRegistry = {
  get: (name: string, version: Version): PlatformConfiguration => {
    return (
      CONFIGURATION_MAP[`${name}_${version}`] || CONFIGURATION_MAP[version]
    );
  },

  getDefault: (version: Version): PlatformConfiguration => {
    return CONFIGURATION_MAP[version];
  },
};
